export default __webpack_public_path__ + "static/media/results.fa0ad73d.png";